module.exports = __webpack_public_path__ + "img/code.17cf5154.svg";